import React, { useEffect, useState } from 'react';
import * as icons from 'react-bootstrap-icons';
import Radio from '@mui/material/Radio';
import { useSelector } from 'react-redux';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function DrawStatusRadios({title, selected, notZero, setStatus}) {
    const [value, setValue] = useState(selected ? selected : 0);
    const { totalStatuses } = useSelector((state) => ({
        totalStatuses: state.setting.totalStatuses,
    }));
    const handleChange = (event) => {
        setValue(+event.target.value);
        setStatus(+event.target.value);
    };

    function GenName({id, name, color}) {
        return (
            <p className='status-text' style={{color: color}}>
                {name}
                {' '}
                {{
                    0: <icons.CalendarPlusFill color={color} size={16}/>,
                    1: <icons.XSquareFill color={color} size={16}/>,
                    2: <icons.XCircleFill color={color} size={16}/>,
                    3: <icons.TelephoneXFill color={color} size={16}/>,
                    4: <icons.CheckSquareFill color={color} size={16}/>,
                    5: <icons.DashCircleFill color={color} size={16}/>,
                    6: <icons.ClipboardCheckFill color={color} size={16}/>,
                    7: <icons.ClockFill color={color} size={16}/>,
                }[id]}
            </p>
        )
    }

    return (
        <FormControl>
            <FormLabel id="statuses-radio-buttons-group">{title}</FormLabel>
            <RadioGroup
                aria-labelledby="statuses-radio-buttons-group"
                name="statuses-radio-buttons-group"
                value={value}
                onChange={handleChange}
            >
                {
                    totalStatuses
                    ? totalStatuses.filter(i => i.status).filter(i => notZero ? i.id !== 0 : i.id !== null).map(item => {
                        return(
                            <FormControlLabel
                                key={`status-radio-${item.id}`}
                                value={item.id}
                                control={<Radio />}
                                label={<GenName id={item.id} color={item.color} name={item.name} /> }
                            />
                        )
                    }) : <small className='each-status w-100 text-center mb-2'>{"وضعیتی ثبت نشده"}</small>
                }
            </RadioGroup>
        </FormControl>
    )
}